import React, { useMemo, useEffect } from 'react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { RouterProvider } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import { createRouter } from './router'
import { AuthProvider } from './lib/auth.context'
import { Toaster } from 'sonner'
import { Toaster as HotToaster } from 'react-hot-toast'
import { ThemeProvider } from './lib/theme-context'
import { handlePreRouterErrors } from './lib/pre-router-error-handler'

export default function App() {
  const queryClient = useMemo(() => new QueryClient({}), [])
  
  // Handle error parameters before router initialization
  useEffect(() => {
    handlePreRouterErrors()
  }, [])
  
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <HelmetProvider>
          <AuthProvider>
            <RouterProvider 
              router={createRouter()} 
              future={{ 
                v7_startTransition: true 
              }} 
            />
            <Toaster />
            <HotToaster position="top-right" />
          </AuthProvider>
        </HelmetProvider>
        <ReactQueryDevtools />
      </ThemeProvider>
    </QueryClientProvider>
  )
}
